module.exports = __webpack_public_path__ + "static/media/grabaseat2.b2ccee7d.jpg";